"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRegionCycle = void 0;
const regions_1 = require("./regions");
const getRegionCycle = (businessUnit, state) => {
    state = state.toUpperCase();
    return regions_1.regions.find((region) => region.businessUnit === businessUnit &&
        region.states.some((stateItem) => stateItem === state));
};
exports.getRegionCycle = getRegionCycle;
